import { IDmLoaiDangKyHoc } from "./../../../model/respone/category/IDmLoaiDangKyHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmLoaiDangKyHocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmLoaiDangKyHoc[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IDmLoaiDangKyHoc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IDmLoaiDangKyHoc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eDmLoaiDangKyHocActionIds = generateActionTypeIds(
  eDmLoaiDangKyHocActionsObj,
  "LOAI_DANG_KY_HOC"
);

export type IDmLoaiDangKyHocActionTypes = IGenericActionType<
  typeof eDmLoaiDangKyHocActionsObj,
  "LOAI_DANG_KY_HOC"
>;
